import { useWhatIsNewModal, WhatIsNewByFeature, WhatIsNewFullScreen } from "sections/whatIsNew";
import { FLAG_WHAT_IS_NEW, KeyWhatIsNewType } from "state/useFlag";

const WhatIsNew = () => {
  // const { open, handleLastClose } = useWhatIsNewModal(FLAG_WHAT_IS_NEW.full);
  const { open, handleLastClose } = useWhatIsNewModal(FLAG_WHAT_IS_NEW.whiteness);
  return open && <WhatIsNewFullScreen open={open} handleClose={handleLastClose} />;
};

export default WhatIsNew;

type RenderWhatIsNewByFeatureProps = {
  flagWhatNew?: KeyWhatIsNewType;
};
export const RenderWhatIsNewByFeature = ({ flagWhatNew }: RenderWhatIsNewByFeatureProps) => {
  const { open, handleClose, handleLastClose } = useWhatIsNewModal(flagWhatNew);
  return (
    <div>
      <WhatIsNewByFeature
        open={open}
        onClose={handleClose}
        onCloseShowAgain={handleLastClose}
        feature={flagWhatNew}
      />
    </div>
  );
};
